import roles from "helpers/roles";
import mainAccess from "helpers/access";

const USER_EDIT_ACCESS = ["F", "E"];

// Mirrors the backend's authorize rule on the per-user locale-preference
// endpoints: admins/client-admins, or a position with user edit access.
export const canEditUserLanguagePreference = (role, position) =>
	role === roles.superAdmin ||
	role === roles.clientAdmin ||
	USER_EDIT_ACCESS.includes(position?.[mainAccess.userAccess]);
